import Image from 'next/image';
import styled, { keyframes } from 'styled-components';
import { DangerousInnerHTML } from '@/shared/components/dangerous-inner-html';
const animArrow = keyframes`
  0% {
    transform: translate(0%, 0%);
  }
  35% {
    transform: translate(0%, 20%);
  }
  50% {
    transform: translate(0%, 15%);
  }
  65% {
    transform: translate(0%, 20%);
  }
  100% {
    transform: translate(0%, 0%);
  }
`;
const showArrow = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 238px;
  height: 239px;
  position: fixed;
  bottom: 18px;
  left: 6px;
  animation:
    ${showArrow} 0.5s 3s ease-in-out forwards,
    ${animArrow} 2s 3s ease-in-out infinite forwards;
  opacity: 0;
`;
export const ArrowIcon = styled(Image)`
  width: 238px;
  height: 239px;
`;
export const TextContent = styled(DangerousInnerHTML)`
  position: absolute;
  top: 93px;
  left: 54px;
  width: 130px;
  height: 70px;
  padding: 0 10px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
`;

/* IE && FF && NewVersions of Chrome styles */

const TopArrowAnimation = keyframes`
  0% {
  transform: translate(0)
  }

  35% {
  transform: translateY(20%)
  }

  50% {
  transform: translateY(15%)
  }

  65% {
  transform: translateY(20%)
  }

  to {
    transform: translate(0)
}`;
export const WrapperTop = styled.div`
  position: fixed;
  bottom: auto;
  left: auto;
  right: 50px;
  top: 50px;
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
`;
export const TextContentTopArrow = styled(DangerousInnerHTML)`
  align-items: center;
  background-image: url(https://cdn-gpd.x-plarium.com/browser/content/lps/info_Icons/adviceRaidAlt_2.png);
  background-position: 100% 0;
  color: #fff;
  display: flex;
  height: 122px;
  padding: 10px 177px 30px 0;
  text-align: right;
  width: 300px;
  animation: ${TopArrowAnimation} 2s infinite;
  background-repeat: no-repeat;
  font-family:
    Open Sans Bold,
    sans-serif;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  transform: translate(0);
`;